import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import type {RootState} from './store';
import {TypedDispatch} from './store';

export const useAppDispatch = () => useDispatch<TypedDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
